import ProgressLoader from './ProgressLoader';

export default ProgressLoader;
